module.exports = __webpack_public_path__ + "static/img/award.fd0828dd.png";